var map = {
	"./WYKRYWANIE.png": "10a2",
	"./ZACHOWYWANIE.png": "c256",
	"./advanced-image-first.jpg": "8c70",
	"./advanced-image-second.png": "d9b7",
	"./ahb-background.jpg": "b08d",
	"./asystent.png": "1ad8",
	"./header-background.jpg": "ca34",
	"./ldw-background.jpg": "b175",
	"./martwe-pole.jpg": "4ce9",
	"./plug-in-background.jpg": "c984",
	"./rcta-background.jpg": "cba2",
	"./rcta-image.jpg": "6b2b",
	"./slider-image.jpg": "58c0",
	"./video-slider-first.png": "4974",
	"./video-slider-second.png": "1079"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0cec";